import React from 'react';
import { Link } from "react-router-dom"
import { Navbar, Nav, Button, ButtonToolbar } from 'react-bootstrap'

const Header = () => (
    <Navbar bg="success" variant="dark">
        <Link to="/"><Navbar.Brand>Token Factory &amp; Market</Navbar.Brand></Link>
        <Nav className="mr-auto">
            <Link to="/"> <span style={{ color: "white", display: 'block', margin: '5px' }}>Home</span></Link>
            <Link to="/"><span style={{ color: "white", display: 'block', margin: '5px' }}>Token Factory</span></Link>
            <Link to="/market"><span style={{ color: "white", display: 'block', margin: '5px' }}>Token Market</span></Link>
        </Nav>

        <ButtonToolbar>
            <Link to="/newtoken"><Button variant="outline-light">Create Token</Button></Link>
            <Link to="/newsale"><Button variant="outline-light">Sell Token</Button></Link>
            <Link to="/market"><Button variant="outline-light">Buy Token</Button></Link>
        </ButtonToolbar>
    </Navbar>
)

export default Header